import { render } from "./MshelFoundation.vue?vue&type=template&id=5872e221&scoped=true"
import script from "./MshelFoundation.vue?vue&type=script&lang=js"
export * from "./MshelFoundation.vue?vue&type=script&lang=js"

import "./MshelFoundation.vue?vue&type=style&index=0&id=5872e221&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5872e221"]])

export default __exports__